import React from 'react';
import { ErrorPermissionBox } from 'components/error-handle/errors';

export function ErrorPermissionPage() {
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <ErrorPermissionBox />
        </div>
      </div>
    </div>
  );
}
